import { useQuery } from '@apollo/client'

import {
  CommandModule,
  DEFAULT_TICKET_ACTIONS,
  DynamicActionsProps,
} from './config'

import { useProject } from '@/context/projectContext'
import { BabyTicket } from '@/modules/tickets/BabyTicket'
import { GET_TICKETS_BY_WOKRER_FOR_SEARCH } from '@/modules/tickets/graphQL'
import { getWorkerName, routes } from '@/utils/index'

import {
  TicketsByWorkersForSearchUiQuery,
  TicketsByWorkersForSearchUiQueryVariables,
} from 'types/api.graphql'

export const DynamicTicketActions: React.FC<DynamicActionsProps> = ({
  activePage,
  debouncedSearchText,
  replaceParentSubItems,
}) => {
  const { project, isProjectSelected } = useProject()

  useQuery<
    TicketsByWorkersForSearchUiQuery,
    TicketsByWorkersForSearchUiQueryVariables
  >(GET_TICKETS_BY_WOKRER_FOR_SEARCH, {
    variables: {
      searchString: debouncedSearchText,
      filter: {
        projectId: isProjectSelected ? project?.id : undefined,
      },
    },
    skip: activePage !== CommandModule.Tickets || !debouncedSearchText?.length,
    onCompleted: (data) => {
      replaceParentSubItems(CommandModule.Tickets, [
        ...DEFAULT_TICKET_ACTIONS,
        ...(data?.ticketsByWorkers?.map((ticket) => ({
          id: ticket.id,
          name: ticket.ticketTemplate.name,
          description: getWorkerName(ticket.worker),
          extra: <BabyTicket ticket={ticket} />,
          href: routes.workers.view(ticket.worker.id, { tab: 'tickets' }),
        })) ?? []),
      ])
    },
  })

  return null
}
